import React from 'react';
import ReactDOM from 'react-dom';
import TripBoardModalContainer from '../TripBoardModal/TripBoardModalContainer';
import edap from '../../utils/edap';
import TestExposureOnce from '../../utils/testExposureOnce';
import {NEW_MODAL} from '../../constants';

const TripBoard = {
    id: 'trip-board-modal-container',

    modal: {
        close: () => {},
        open: () => {}
    },

    siteName: null,

    getTripboards: null,

    createToast: null,

    tripBoardButton: null,

    translations: null,

    testExposure: {
        newModal: new TestExposureOnce(NEW_MODAL)
    },

    close() {
        this.tripBoardButton = null;
        this.modal.close();
        return this;
    },

    setVisibilityListener() {
        let visibilityChange = null;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
            }

            document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this), false);
        }
    },

    handleVisibilityChange() {
        if (!document.hidden) {
            // the handler fires twice for hidden = false and hidden = true.  We only need one.
            this.getTripboards(this.siteName);
        }
    },

    setSitename(siteName) {
        this.siteName = siteName;
    },

    setGetTripboards(getTripboards) {
        this.getTripboards = getTripboards;
    },

    setCreateToast(createToast) {
        this.createToast = createToast;
    },

    create(createBoard, newBoardName) {
        const tripBoardRef = this.tripBoardButton;
        let {adultsCount, childrenCount, listingId, thumbnailUrl, petIncluded, startDate, endDate} = tripBoardRef.props;
        // guard against empty strings
        if (!startDate || !endDate) {
            startDate = null;
            endDate = null;
        }

        createBoard({
            listings: [
                {
                    listingId,
                    startDate,
                    endDate
                }
            ],
            adultsCount,
            childrenCount,
            petIncluded,
            startDate,
            endDate,
            name: newBoardName,
            thumbnailUrl
        });

        this.close();
    },

    add(addToBoard, boardId) {
        const {
            adultsCount,
            childrenCount,
            listingId,
            petIncluded,
            thumbnailUrl,
            tripboards,
            startDate,
            endDate
        } = this.tripBoardButton.props;
        addToBoard({
            adultsCount,
            boardId,
            childrenCount,
            listingId,
            petIncluded,
            startDate,
            endDate,
            thumbnailUrl
        });

        const boardsPosition = tripboards.boards.findIndex((tripboard) => {
            return tripboard.boardId === boardId;
        });
        const boardsLength = tripboards.boards.length;
        const tripboard = tripboards.boards[boardsPosition];
        const {user} = tripboard || {};
        const {role = {}} = user || {};
        // update UI
        this.confirm(tripboard.name, thumbnailUrl, listingId, boardId);
        this.close();

        // triger EDAP events
        edap.boardAdd(boardsPosition, boardsLength, listingId, boardId, role.type);
    },

    confirm(name, thumbnail, listingId, boardId) {
        const toastMessage = () => {
            return (
                <span>
                    {this.translations['tripboards.toaster.added.to']}
                    <br />
                    <a href={`/tripboard/${boardId}`} className="toaster__toast-link">
                        {name}
                    </a>
                </span>
            );
        };

        const onAutoClose = () => {
            edap.toasterAutoClose(listingId, boardId);
        };

        const onClose = () => {
            edap.toasterClose(listingId, boardId);
        };

        const onContentClick = () => {
            edap.toasterClick(listingId, boardId);
        };

        const onCloseClick = () => {
            edap.toasterDismiss(listingId, boardId);
        };

        this.createToast({
            onAutoClose,
            onClose,
            onCloseClick,
            onContentClick,
            renderContent: toastMessage,
            thumbnail,
            type: 'inverse'
        });

        edap.toasterView(listingId, boardId);
    },

    showCreateError(listingId) {
        const toastMessage = () => {
            return (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <i className="icon-alert icon-error icon-lg" aria-hidden="true" />
                    <div style={{paddingLeft: '15px'}}>{this.translations['tripboards.error']}</div>
                </div>
            );
        };

        this.createToast({
            renderContent: toastMessage,
            type: 'inverse'
        });

        edap.toasterError(listingId);
    },

    getPropsFromTripboardButton(tripBoardButton) {
        const tripBoards = (tripBoardButton.props.tripboards && tripBoardButton.props.tripboards.boards) || [];
        const props = {
            listingId: tripBoardButton.props.listingId,
            position: tripBoardButton.props.position || 'right',
            refButton: tripBoardButton.refButton,
            thumbnailUrl: tripBoardButton.props.thumbnailUrl,
            createBoard: tripBoardButton.props.createBoard,
            addToBoard: tripBoardButton.props.addToBoard,
            translations: this.translations,
            tripBoards,
            rating: tripBoardButton.props.rating,
            headline: tripBoardButton.props.headline,
            reviewCount: tripBoardButton.props.reviewCount
        };
        return props;
    },

    remove(removeFromBoard, listingId) {
        removeFromBoard({listingId});
        edap.heartClickOff(listingId);
    },

    open(tripBoardButton) {
        this.tripBoardButton = tripBoardButton;
        this.translations = tripBoardButton.props.translations;

        const props = this.getPropsFromTripboardButton(tripBoardButton);

        // Position left on PDP instead of bottom.
        // TODO: We need to fix this in GT!!!!
        props.position = props.position === 'bottom' ? 'left' : props.position;

        // decorate
        props.onCreate = this.create.bind(this);
        props.onAdd = this.add.bind(this);

        if (!this.isRendered()) {
            this.render();
        }

        this.modal.open(props);

        edap.heartClickOn(props.listingId);

        if (typeof window !== 'undefined' && typeof window.__ABACUS__ !== 'undefined') {
            this.testExposure.newModal.trigger();
        }

        return this;
    },

    render(props = {}) {
        const modalContainer = this.getContainerElement();
        this.modal = ReactDOM.render(<TripBoardModalContainer {...props} />, modalContainer);
    },

    getContainerElement() {
        let container = document.getElementById(this.id);

        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', this.id);
            document.body.appendChild(container);
        }

        return container;
    },

    isRendered() {
        return this.modal instanceof React.Component;
    }
};

export default TripBoard;
